var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/actions/ButtonCreateVariant/ButtonCreateVariant.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { Button } from '@wds/button';
import { T } from '@sm/intl';
import { generateMetricsAttribute } from '@sm/metrics';
import { Sheet } from '@wds/sheet';
import HeaderContext from '../../../HeaderContext';
import { ExperimentVariant, View } from './types';
import { DrillDownMenuVariant, SingleLevelVariant } from './ButtonCreateVariants';
export var COPY = {
  createSurvey: {
    id: 'ButtonCreateVariant.createSurvey',
    defaultMessage: 'Create survey',
    description: '[Type: Button][Vis.: high] - This is the create survey addon button on the header.'
  }
};
var useStyles = createUseStyles(function (theme) {
  return {
    container: {
      color: theme.palette.text.dark
    }
  };
});
var ButtonCreate = function ButtonCreate(_ref) {
  var treatment = _ref.treatment;
  var _useContext = useContext(HeaderContext),
    pageURL = _useContext.pageURL,
    pageName = _useContext.pageName;
  var _useState = useState(View.None),
    _useState2 = _slicedToArray(_useState, 2),
    view = _useState2[0],
    setView = _useState2[1];
  var _useStyles = useStyles(),
    container = _useStyles.container;
  return /*#__PURE__*/React.createElement("div", {
    className: container,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: "alt",
    onClick: function onClick() {
      return setView(View.StartingPoint);
    },
    "data-sm-metrics": generateMetricsAttribute({
      data: {
        url: pageURL,
        pageName: pageName,
        amplitudeEvent: 'header clicked cta',
        ctaName: 'create survey'
      }
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.createSurvey,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Sheet, {
    show: view !== View.None,
    onClose: function onClose() {
      return setView(View.None);
    },
    size: "md",
    elevation: 10000,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 7
    }
  }, treatment === ExperimentVariant.DrillDownMenu ? /*#__PURE__*/React.createElement(DrillDownMenuVariant, {
    view: view,
    setView: setView,
    pageName: pageName !== null && pageName !== void 0 ? pageName : '',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 13
    }
  }) : /*#__PURE__*/React.createElement(SingleLevelVariant, {
    view: view,
    pageName: pageName !== null && pageName !== void 0 ? pageName : '',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 13
    }
  })));
};
export default ButtonCreate;
//# sourceMappingURL=ButtonCreateVariant.js.map